import { Form, Formik } from 'formik'
import React from 'react'

import { LeavingGuard } from '@components/utils/LeavingGuard'
import { HeadContent, Skeleton } from '@fourthwall/components'
import { ConfirmBar } from '@modules/Dashboard/modules/ConfirmBar'

import type { FieldValues } from './EmailNotifications.types'
import { AccountNotifications } from './components/AccountNotifications/AccountNotifications'
import { MarketingEmails } from './components/MarketingEmails/MarketingEmails'
import { Memberships } from './components/Memberships/Memberships'
import { useEmailNotifications } from './hooks/useEmailNotifications'

export const EmailNotifications = () => {
  const { handleSubmit, initialValues } = useEmailNotifications()

  if (!initialValues) {
    return (
      <div>
        <HeadContent title="Email notifications &ndash; Account settings" />
        <Skeleton gap={16}>
          <Skeleton.Shape height={45} width="80%" />
          <Skeleton.Shape height={45} width="80%" />
          <Skeleton.Shape height={45} width="80%" />
        </Skeleton>
      </div>
    )
  }

  return (
    <div>
      <HeadContent title="Email notifications &ndash; Account settings" />
      <Formik<FieldValues> initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
        {({ dirty, isValid, isSubmitting, submitForm, resetForm }) => (
          <Form>
            <MarketingEmails />
            <AccountNotifications />
            <Memberships />
            <ConfirmBar
              isOpen={dirty}
              isLoading={isSubmitting}
              onConfirm={submitForm}
              onCancel={resetForm}
            />
            <LeavingGuard when={dirty} isValid={isValid} onSave={submitForm} />
          </Form>
        )}
      </Formik>
    </div>
  )
}
